import { produce } from 'immer';

import { UpdateImportExportWizardVisibility } from '../../actions/importExportWizard/updateImportExportWizardVisibility';
import { ImportExportWizardState, ImportExportWizardStatus } from '../../typings/importExportWizard';

export function updateImportExportWizardVisibility(
    state: ImportExportWizardState,
    action: UpdateImportExportWizardVisibility
): ImportExportWizardState {
    return produce(state, draft => {
        draft.isVisible = action.isVisible;

        if (!action.isVisible) {
            draft.status = ImportExportWizardStatus.SAVED;
        }
    });
}
